// extracted by mini-css-extract-plugin
module.exports = {"skillsMainDiv":"Skills_skillsMainDiv__6_siC","skillsDiv":"Skills_skillsDiv__XYGsZ","skillItem":"Skills_skillItem__2cwI2"};